import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import { rgba } from 'foundations-components/transitional/utils/color';
import { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCollectionCardWrapper = styled.div.withConfig({
  displayName: "CollectionCardWrapper__StyledCollectionCardWrapper",
  componentId: "sc-1pw8h31-0"
})(({
  $cssStyles
}) => {
  const theme = useTheme();
  return Object.assign({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 0,
    backgroundColor: theme.color['fill-surface-default'],
    boxShadow: `0 1px 5px 0 ${rgba(theme.color['fill-accent-neutral-default'], 0.12)}`,
    height: 'inherit',
    border: '2px solid transparent',
    borderRadius: theme.borderRadius['100'],
    transition: 'border 150ms ease-out',
    '&:hover': {
      borderColor: theme.color['border-interactive-default']
    }
  }, $cssStyles);
});
export const CollectionCardWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledCollectionCardWrapper, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    ref: ref,
    children: children
  }));
});